import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { ESIGN_SEND_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class SendEsignPackageRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {};

  url = ESIGN_SEND_URL;

  constructor(applicationId) {
    super();

    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
